import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { apiClient } from "@/lib/client";
import { ENDPOINTS } from "@/api/endpoints";

export interface InsightByDate {
  id: number;
  scheduledJobId: number;
  processDate: string;
  styleId: string;
  predictedUnitSales: number;
  predictedRevenue: number;
  imageLink: string;
  productLink: string;
  launchYear: number;
  season: string;
  rating: number;
  brand: string;
  article: string;
  colour: string;
  occasion: string;
  mrp: number;
  availableCount: number;
  averageSellingPrice: number;
  averageDiscountPercentage: number;
  createdBy: string | null;
  createdAt: string;
  lastModifiedBy: string | null;
  lastModifiedAt: string;
}

interface GetInsightsByDateParams {
  jobId: string;
  date: string;
  trendDate: string;
}

const getInsightsForJobByTrendingStyle = async ({
  jobId,
  date,
  trendDate,
}: GetInsightsByDateParams): Promise<InsightByDate[]> => {
  return apiClient
    .get(
      ENDPOINTS.GET_INSIGHTS_FOR_JOB_BY_TRENDING_STYLE(jobId, date, trendDate)
    )
    .json<InsightByDate[]>();
};

export const useGetInsightsForJobByTrendingStyleQuery = (
  params: GetInsightsByDateParams,
  options?: Omit<
    UseQueryOptions<InsightByDate[], Error>,
    "queryKey" | "queryFn"
  >
) => {
  return useQuery({
    queryKey: [
      "jobInsightsByTrendingStyle",
      params.jobId,
      params.date,
      params.trendDate,
    ],
    queryFn: () => getInsightsForJobByTrendingStyle(params),
    ...options,
  });
};
